<template>
  <div>
    <h1 class="heading text-3xl">Puzzle: {{ number }}</h1>
    <h3 v-if="startTime > 0" class="text-2xl font-main my-2">
      Time Remaining: {{ time }}
    </h3>
    <div class="img-container md:px-6">
      <img
        id="image"
        :src="`/img/${name}.jpg`"
        alt="Map Problem"
        height="500px"
      />
    </div>

    <div v-if="startTime > 0" class="choices mt-2">
      <button class="button red" @click="selectChoice(1)">1</button>
      <button class="button green" @click="selectChoice(2)">2</button>
      <button class="button blue" @click="selectChoice(3)">3</button>
    </div>
    <button
      v-if="startTime > 0"
      class="button skip white"
      @click="selectChoice(0)"
    >
      Skip
    </button>
  </div>
</template>

<script>
export default {
  props: {
    number: {
      type: Number,
      default: '',
    },
    name: {
      type: String,
      deafult: '',
    },
  },

  data: function() {
    return {
      time: 0,
      startTime: 0,
      interval: [],
    }
  },

  mounted: function() {
    const vue = this

    document.addEventListener('keydown', function(event) {
      const oneKey = [35, 49, 97]
      const twoKey = [40, 50, 98]
      const threeKey = [34, 51, 99]

      if (oneKey.includes(event.keyCode)) vue.selectChoice(1)
      if (twoKey.includes(event.keyCode)) vue.selectChoice(2)
      if (threeKey.includes(event.keyCode)) vue.selectChoice(3)
    })

    const image = document.getElementById('image')
    if (image.complete) this.startTimer()
    else document.getElementById('image').onload = this.startTimer
  },

  methods: {
    tick: function() {
      this.time -= 1
      if (this.time <= 0) this.timeOver()
    },

    startTimer: function() {
      this.time = 20
      this.startTime = Date.now()

      const tickFunction = this.tick
      this.interval = setInterval(tickFunction, 1000)
    },

    clearTimer: function() {
      clearInterval(this.interval)
    },

    timeOver: function() {
      this.selectChoice(0)
    },

    selectChoice: function(choice) {
      const time = Date.now() - this.startTime
      this.clearTimer()

      this.$emit('complete', { choice: choice, time: time })
    },
  },
}
</script>
